<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.location_management }}
      </v-card-title>
    </v-card>

    <!-- popup เพิ่ม/แก้ไข -->
    <v-dialog v-model="dialog" scrollable max-width="520" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1">
        <v-card-title class="height-57">
          <span v-if="location.id == 0">{{ use_language.add_location }}</span>
          <span v-else>{{ use_language.edit_location }}</span>
          <v-spacer/>
          <v-btn icon @click="dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-x-auto">
          <v-form ref="locationForm" lazy-validation>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.channel }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <!-- เปลี่ยนช่องทางหลังสร้างแล้วไม่ได้ เพราะผู้ใช้และโควตาผูกกับช่องทางเดิม -->
                <v-select
                  v-model="location.channel"
                  :items="channelItems"
                  :disabled="location.id != 0"
                  :rules="rulesRequired"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.code }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field
                  :value="location.code"
                  @change="value => location.code = Trim_value(value)"
                  autocomplete="off"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.name }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field
                  :value="location.name"
                  @change="value => location.name = Trim_value(value)"
                  autocomplete="off"
                  :rules="rulesRequired"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="location.id != 0">
              <v-col cols="12" md="3" class="pa-0"></v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-checkbox v-model="location.isActive" :label="use_language.active" class="mt-0"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0" align="right">
                <v-btn :elevation="1" color="primary" class="px-2" @click="Save()">
                  <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                  <span class="fn-14"><b> {{ use_language.record }} </b></span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <oms-import-dialog
      v-model="importDialog"
      :title="use_language.import_excel + ' : ' + use_language.location"
      :hint="use_language.import_hint_location"
      :columns="importColumns"
      :template-rows="importTemplateRows"
      template-name="oms_location_template"
      :import-fn="importLocation"
      @done="Load_data()"
    />

    <!-- รายการ -->
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="22" color="success darken-3">mdi-map-marker-multiple</v-icon><span class="ml-3">{{ use_language.location }}</span>
        <v-spacer/>
        <v-btn :elevation="1" outlined color="success" class="px-2 mr-2" @click="importDialog = true">
          <v-icon size="20" class="mr-1">mdi-file-excel</v-icon>
          {{ use_language.import_excel }}
        </v-btn>
        <v-btn :elevation="1" color="primary" class="px-2" @click="Edit(null)">
          <v-icon size="22" class="mr-1">mdi-plus</v-icon>
          {{ use_language.add_location }}
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row class="pb-2">
          <v-col cols="12" md="6" class="pa-1">
            <v-tabs v-model="tab">
              <v-tab v-for="item in tabItems" :key="item.value">{{ item.text }} ({{ formatMoney(String(countOf(item.value))) }})</v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field
              v-model="keyword"
              :placeholder="use_language.search"
              prepend-inner-icon="mdi-magnify"
              autocomplete="off"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- PC hidden-xs-only -->
        <v-data-table
          :headers="header"
          :items="filtered"
          :items-per-page="50"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
          :no-data-text="use_language.no_data"
          class="packhai-border-table hidden-xs-only"
        >
          <template v-slot:item.no="{ item }">{{ filtered.indexOf(item) + 1 }}</template>
          <template v-slot:item.isActive="{ item }">
            <span v-if="item.isActive" style="color: darkgreen;">{{ use_language.active }}</span>
            <span v-else style="color: red;">{{ use_language.inactive }}</span>
          </template>
          <template v-slot:item.edit="{ item }">
            <a @click="Edit(item)"><v-icon size="18">fa-edit</v-icon></a>
          </template>
        </v-data-table>

        <!-- Mobile hidden-sm-and-up -->
        <v-data-iterator
          :items="filtered"
          :items-per-page="50"
          :no-data-text="use_language.no_data"
          class="hidden-sm-and-up"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.id" cols="12" class="pa-1">
                <v-card>
                  <v-row class="pa-2">
                    <v-col cols="12" class="pa-0">{{ use_language.channel }} : {{ item.channel }}</v-col>
                    <v-col cols="12" class="pa-0" v-if="item.code != null">{{ use_language.code }} : {{ item.code }}</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.name }} : {{ item.name }}</v-col>
                    <v-col cols="8" class="pa-0">
                      {{ use_language.status }} :
                      <span v-if="item.isActive" style="color: darkgreen;">{{ use_language.active }}</span>
                      <span v-else style="color: red;">{{ use_language.inactive }}</span>
                    </v-col>
                    <v-col cols="4" class="pa-0 text-right">
                      <a @click="Edit(item)"><v-icon size="16" class="mr-2">fa-edit</v-icon></a>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Loading from '@/website/components/Loading'
  import OmsImportDialog from '@/website/backend/oms/components/OmsImportDialog'
  import { formatMoney, Trim_value } from '@/website/global_function'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { getLocationList, saveLocation, importLocation } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading,
      OmsImportDialog
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),

      tab: 0,
      keyword: null,
      dataset: [],

      // popup
      dialog: false,
      importDialog: false,
      location: {},
      rulesRequired: []
    }),
    computed: {
      tabItems () {
        return [
          { value: null, text: this.use_language.all },
          { value: 'ON', text: 'ON' },
          { value: 'TT', text: 'TT' }
        ]
      },
      channelItems () {
        return [
          { value: 'ON', text: this.use_language.channel_on },
          { value: 'TT', text: this.use_language.channel_tt }
        ]
      },
      header () {
        return [
          { text: this.use_language.no, align: 'center', sortable: false, value: 'no', width: '70px' },
          { text: this.use_language.channel, align: 'center', value: 'channel', sortable: false, width: '100px' },
          { text: this.use_language.code, align: 'center', value: 'code', sortable: false, width: '140px' },
          { text: this.use_language.name, align: 'left', value: 'name', sortable: false },
          { text: this.use_language.status, align: 'center', value: 'isActive', sortable: false, width: '120px' },
          { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false, width: '90px' }
        ]
      },
      filtered () {
        const channel = this.tabItems[this.tab].value
        const keyword = (this.keyword || '').trim().toLowerCase()
        return this.dataset.filter(item =>
          (channel == null || item.channel == channel) &&
          (keyword == '' || item.name.toLowerCase().includes(keyword) || (item.code || '').toLowerCase().includes(keyword))
        )
      },
      importColumns () {
        return [
          { key: 'channel', header: 'ช่องทาง', aliases: ['Channel'] },
          { key: 'code', header: 'รหัส', aliases: ['Code'] },
          { key: 'name', header: 'ชื่อ Location', aliases: ['Storage Location', 'Location', 'Name', 'ชื่อ'] }
        ]
      },
      importTemplateRows () {
        return [
          ['ON', '', 'จังหวัดนนทบุรี (1)'],
          ['TT', '1017', '1017 Pull']
        ]
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      formatMoney,
      Trim_value,
      importLocation,
      countOf (channel) {
        return this.dataset.filter(item => channel == null || item.channel == channel).length
      },
      showError (response) {
        this.$swal({
          position: 'top',
          type: 'error',
          text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
        })
      },
      async Load_data () {
        this.loading = true
        const response = await getLocationList({})
        this.loading = false
        if (response.status == 'success') {
          this.dataset = response.items
        } else {
          this.showError(response)
        }
      },
      Edit (item) {
        if (item != null) {
          this.location = { ...item }
        } else {
          const channel = this.tabItems[this.tab].value
          this.location = { id: 0, channel: channel, code: null, name: null, isActive: true }
        }
        this.rulesRequired = []
        this.dialog = true
      },
      async Save () {
        this.rulesRequired = [v => !!v || this.use_language.please_specify]
        await this.$nextTick()
        if (!this.$refs.locationForm.validate()) {
          return
        }
        this.loading = true
        const response = await saveLocation(this.location)
        this.loading = false
        if (response.status != 'success') {
          this.showError(response)
          return
        }
        await this.Load_data()
        this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
        this.dialog = false
      }
    }
  }
</script>
